"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHARD_CATALOG_GROUP_COPY = void 0;
exports.SHARD_CATALOG_GROUP_COPY = {
    customer: 'Customer',
    org: 'Organization',
    user: 'User'
};
//# sourceMappingURL=SHARD_CATALOG_GROUP_COPY.js.map